import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Grid } from '@mui/material';
export const FinishPage = () => {
    const thankYouText = `Thanks, you're all set up!`;
    return (_jsx(Box, { sx: { width: '100%', height: '100%' }, children: _jsxs(Grid, { container: true, justifyContent: "center", alignContent: "center", height: "100%", children: [_jsx(Grid, { item: true, children: _jsx("p", { children: thankYouText }) }), _jsx(Grid, { item: true, children: _jsx("p", { children: _jsx("small", { children: "If you need to change any of your details, just go to settings in your menu." }) }) })] }) }));
};
